var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1675_98781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 1C10.1637 1 10.418 1.10536 10.6055 1.29289C10.7931 1.48043 10.8984 1.73478 10.8984 2V8C10.8984 8.26522 10.7931 8.51957 10.6055 8.70711C10.418 8.89464 10.1637 9 9.89844 9H8.89844V10C8.89844 10.2652 8.79308 10.5196 8.60554 10.7071C8.41801 10.8946 8.16365 11 7.89844 11H2.89844C2.63322 11 2.37887 10.8946 2.19133 10.7071C2.00379 10.5196 1.89844 10.2652 1.89844 10V4C1.89844 3.73478 2.00379 3.48043 2.19133 3.29289C2.37887 3.10536 2.63322 3 2.89844 3H3.89844V2C3.89844 1.73478 4.00379 1.48043 4.19133 1.29289C4.37887 1.10536 4.63322 1 4.89844 1H9.89844ZM7.89844 4H2.89844V10H7.89844V4ZM5.39844 7.5C5.53105 7.5 5.65822 7.55268 5.75199 7.64645C5.84576 7.74021 5.89844 7.86739 5.89844 8C5.89844 8.13261 5.84576 8.25979 5.75199 8.35355C5.65822 8.44732 5.53105 8.5 5.39844 8.5H4.39844C4.26583 8.5 4.13865 8.44732 4.04488 8.35355C3.95112 8.25979 3.89844 8.13261 3.89844 8C3.89844 7.86739 3.95112 7.74021 4.04488 7.64645C4.13865 7.55268 4.26583 7.5 4.39844 7.5H5.39844ZM9.89844 2H4.89844V3H7.89844C8.16365 3 8.41801 3.10536 8.60554 3.29289C8.79308 3.48043 8.89844 3.73478 8.89844 4V8H9.89844V2ZM6.39844 5.5C6.52588 5.50014 6.64845 5.54894 6.74112 5.63642C6.83379 5.72391 6.88955 5.84348 6.89702 5.9707C6.90449 6.09792 6.8631 6.22319 6.78131 6.32092C6.69951 6.41864 6.58349 6.48145 6.45694 6.4965L6.39844 6.5H4.39844C4.271 6.49986 4.14842 6.45106 4.05575 6.36358C3.96309 6.27609 3.90732 6.15652 3.89985 6.0293C3.89238 5.90208 3.93377 5.77681 4.01557 5.67908C4.09737 5.58136 4.21339 5.51855 4.33994 5.5035L4.39844 5.5H6.39844Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1675_98781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copyToClipboard.86b4e8e0a5e384430217f0e20fd185d9.svg";
export { ForwardRef as ReactComponent };